fitvids('.video-container')